export const TYPE_LABEL = {
  script: "Roteiro",
  carrossel: "Carrossel",
  calendar: "Calendário",
  metrics: "Métricas",
  pricing: "Precificação",
  brand: "Brand Persona",
};

export const TYPE_FILTERS = ["all", "script", "carrossel", "calendar", "metrics", "pricing", "brand"];

export const LIBRARY_VIEW_KEY = "valiosia_library_view";
export const LIBRARY_VIEWS = ["cards", "table"];

function defaultStorage() {
  return typeof localStorage === "undefined" ? null : localStorage;
}

export function readLibraryView(storage = defaultStorage()) {
  try {
    const v = storage?.getItem(LIBRARY_VIEW_KEY);
    return LIBRARY_VIEWS.includes(v) ? v : "cards";
  } catch {
    return "cards";
  }
}

export function writeLibraryView(view, storage = defaultStorage()) {
  if (!LIBRARY_VIEWS.includes(view)) return;
  try { storage?.setItem(LIBRARY_VIEW_KEY, view); } catch { /* private mode */ }
}

export const STATUS_LABEL = {
  saved: "Salvo",
  draft: "Rascunho",
};

export function agentLabel(slug, bySlug = {}) {
  if (!slug) return "—";
  return bySlug[slug]?.nome || slug;
}

export function continueAgentPath(item) {
  const slug = item?.agent_slug;
  if (!slug) return null;
  if (slug === "brand-persona") return "/marca";
  if (slug === "avatar-builder") return "/avatars";
  const q = item.thread_id ? `?thread=${encodeURIComponent(item.thread_id)}` : "";
  return `/agent/${slug}${q}`;
}

export function filterLibraryItems(items, { status = "saved", type = "all", agent = "all" } = {}) {
  return (items || []).filter((it) => {
    if (status && status !== "all" && it.status !== status) return false;
    if (type && type !== "all" && it.type !== type) return false;
    if (agent && agent !== "all" && (it.agent_slug || "") !== agent) return false;
    return true;
  });
}

export function sortLibraryItems(items, { key = "updated_at", dir = "desc" } = {}, bySlug = {}) {
  const m = dir === "asc" ? 1 : -1;
  const val = (it) => {
    if (key === "title") return (it.title || "").toLowerCase();
    if (key === "type") return (TYPE_LABEL[it.type] || it.type || "").toLowerCase();
    if (key === "agent") return agentLabel(it.agent_slug, bySlug).toLowerCase();
    if (key === "status") return it.status || "";
    return it.updated_at || "";
  };
  return [...(items || [])].sort((a, b) => {
    const va = val(a);
    const vb = val(b);
    if (va < vb) return -1 * m;
    if (va > vb) return 1 * m;
    return 0;
  });
}

export function agentsInItems(items, bySlug = {}) {
  const seen = new Set();
  const out = [];
  for (const it of items || []) {
    const s = it.agent_slug;
    if (!s || seen.has(s)) continue;
    seen.add(s);
    out.push({ slug: s, nome: agentLabel(s, bySlug) });
  }
  return out.sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
}
